import React from "react";
import { History } from "lucide-react";

const FIELD_LABELS = {
  last_name: "Nom", first_name: "Prénom", email: "Email", phone: "Tél", notes: "Notes", status: "Statut",
  plan_name: "Plan", plan_category: "Catégorie", price_eur: "Prix", payment_type: "Paiement", start_date: "Début", end_date: "Fin",
};

const ACTION_COLORS = {
  CREATE_MEMBER: "bg-green-500", CREATE_SUBSCRIPTION: "bg-green-500",
  DELETE_MEMBER: "bg-red-500", DELETE_SUBSCRIPTION: "bg-red-500", DELETE_SUSPENSION: "bg-red-500",
  UPDATE_MEMBER: "bg-[#3899ec]", UPDATE_SUBSCRIPTION: "bg-[#3899ec]",
  STATUS_CHANGE: "bg-orange-500", RENEWAL_DECISION: "bg-purple-500", CREATE_SUSPENSION: "bg-blue-500",
};

const ActivityEntry = ({ activity }) => (
  <div className="relative pl-10 pb-5" data-testid={`activity-${activity.id}`}>
    <div className={`absolute left-[8px] top-1 w-[16px] h-[16px] rounded-full border-2 border-white ${ACTION_COLORS[activity.action] || "bg-gray-400"}`} />
    <div className="bg-white rounded-lg border border-[#edf0f4] p-3">
      <div className="flex items-center justify-between mb-1">
        <span className="text-sm font-medium text-[#162d3d]">{activity.action_label || activity.action}</span>
        <span className="text-xs text-[#8fa4b5]">
          {activity.timestamp ? new Date(activity.timestamp).toLocaleDateString("fr-BE", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : ""}
        </span>
      </div>
      {activity.details && <p className="text-sm text-[#577083]">{activity.details}</p>}
      {activity.changes && Object.keys(activity.changes).length > 0 && (
        <div className="mt-2 flex flex-wrap gap-2">
          {Object.entries(activity.changes).map(([field, vals]) => (
            <span key={field} className="inline-flex items-center gap-1 text-xs bg-[#f4f7fa] rounded px-2 py-1">
              <span className="font-medium text-[#32536a]">{FIELD_LABELS[field] || field}</span>
              <span className="text-red-400 line-through">{vals.old || "—"}</span>
              <span className="text-[#8fa4b5]">→</span>
              <span className="text-green-600">{vals.new || "—"}</span>
            </span>
          ))}
        </div>
      )}
      {activity.user_name && <p className="text-xs text-[#a1aeba] mt-1">par {activity.user_name}</p>}
    </div>
  </div>
);

export const ActivityTimeline = ({ activities }) => (
  <div className="crm-section" data-testid="activity-history-section">
    <h2 className="crm-section-title flex items-center gap-2">
      <History size={18} className="text-[#3899ec]" /> Historique des modifications
    </h2>
    {activities.length === 0 ? (
      <p className="text-sm text-[#577083] py-3">Aucune activité enregistrée</p>
    ) : (
      <div className="mt-4 relative">
        <div className="absolute left-[15px] top-0 bottom-0 w-[2px] bg-[#edf0f4]" />
        {activities.map((a) => <ActivityEntry key={a.id} activity={a} />)}
      </div>
    )}
  </div>
);
